/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    GetProfileData: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetProfileAction.REQUEST_GETPROFILEDATA:
      return {
        ...state
      };
    case actions.GetProfileAction.GETPROFILEDATA_RECEIVED:
      return {
        ...state,
        GetProfileData: action.data
      };

    default:
      return state;
  }
};

export default reducer;
